export function LeftDataPanel() {
  return (
    <aside className="panel panel-left" id="panelLeft">
      <h2>Data</h2>
      <div className="data-panel-toolbar" aria-label="Data actions">
        <input type="file" id="fileInput" accept=".txt,.dat,.root,.json" multiple hidden />
        <input type="file" id="configInput" accept=".json" hidden />
        <div className="data-toolbar-row data-toolbar-files">
          <button type="button" className="btn btn-secondary btn-toolbar" id="loadConfigBtn" title="Load JSON configuration">
            Load config
          </button>
          <button type="button" className="btn btn-secondary btn-toolbar" id="downloadConfigBtn" title="Save plot settings as JSON">
            Download config
          </button>
          <button type="button" className="btn btn-secondary btn-toolbar" id="addMoreFilesBtn" title="Add ROOT or text files">
            Add more
          </button>
          <button type="button" className="btn btn-secondary btn-toolbar" id="startOverBtn" title="Return to file picker and clear session">
            Start over
          </button>
        </div>
        <div className="data-toolbar-row data-toolbar-actions">
          <button type="button" className="btn btn-primary btn-toolbar" id="plotBtn" title="Plot selected columns or ROOT objects">
            Plot
          </button>
          <button type="button" className="btn btn-secondary btn-toolbar" id="clearPlotCanvasBtn" title="Clear the chart only; keep selections">
            Clear plot
          </button>
          <button type="button" className="btn btn-secondary btn-toolbar" id="clearAllBtn" title="Clear selections and chart">
            Clear
          </button>
        </div>
      </div>
      <div id="leftPanelRoot" className="panel-content root-panel-top panel-scroll">
        <div className="field">
          <label htmlFor="rootTreeFilter">Filter objects</label>
          <input
            type="search"
            id="rootTreeFilter"
            className="root-tree-filter"
            placeholder="Search by name, path, or class…"
            autoComplete="off"
          />
        </div>
        <div className="field">
          <label>ROOT objects</label>
          <div id="rootTreeContainer" className="root-tree" role="tree" aria-label="ROOT file contents" />
        </div>
        <p className="hint small">Expand folders; check objects, then Plot.</p>
      </div>
      <div id="leftPanelTxtDat" className="panel-content panel-scroll">
        <div className="field" id="delimiterField">
          <label htmlFor="delimiter">Delimiter</label>
          <select id="delimiter">
            <option value="auto">Auto</option>
            <option value="tab">Tab</option>
            <option value="space">Space(s)</option>
            <option value="comma">Comma</option>
          </select>
        </div>
        <details className="column-mapping-details" id="columnMappingDetails">
          <summary className="column-mapping-summary">Data columns (X / Y)</summary>
          <div className="field">
            <label>X axis (single)</label>
            <div id="xColumnList" className="column-list" />
          </div>
          <div className="field">
            <label>Y axis (one or more)</label>
            <div id="yColumnList" className="column-list" />
          </div>
        </details>
        <div className="preview-header">
          <h3>Preview</h3>
          <button type="button" className="btn btn-small" id="togglePreviewBtn">
            Show data table
          </button>
        </div>
        <div className="table-wrap" id="previewTableContainer" hidden>
          <table className="data-table" id="previewTable" />
        </div>
        <p className="panel-privacy">Runs in your browser. No data is sent or stored.</p>
      </div>
    </aside>
  );
}
